exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sankey-node .node{cursor:pointer}.sankey-node .node foreignObject body{background:none}.sankey-node .node foreignObject body .content{padding:10px;color:#fff;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f7f5da32","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/Components/Charts/SankeyNode.vue
// module id = 379
// module chunks = 0